import { withPublicWrapper } from '../components/public/Wrapper/withPublicWrapper';
import Intro from 'components/public/Intro/Intro';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { Divider, Col } from 'antd';
import React from 'react';
import ContactForm from 'components/ContactForm';
import Head from 'next/head';
import { useIntl } from 'react-intl';

const Contact = (): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Head>
        <title>Hitch and Hike - Contact</title>
      </Head>
      <Intro
        title={formatMessage({
          defaultMessage: 'Contact us',
          description: 'contact/title',
        })}
        image={{ src: '/logo.png', alt: 'logo', width: '1779', height: '1608' }}
        descriptionText={formatMessage({
          defaultMessage: "Let's discover what we can do",
          description: 'contact/description',
        })}
      />

      <IntroBlock
        type="white"
        title=""
        description={
          <Col>
            <p>
              {formatMessage({
                defaultMessage: "Don't hesitate to contact us.",
                description: 'contact/block/description/1',
              })}
            </p>
            <p>
              {formatMessage({
                defaultMessage: 'You want our off the shelve integrations to be available for you?',
                description: 'contact/block/description/2',
              })}
            </p>
            <p>
              {formatMessage({
                defaultMessage: 'You want something custom?',
                description: 'contact/block/description/3',
              })}
            </p>
            <p>
              {formatMessage({
                defaultMessage: 'Another question? Shoot!',
                description: 'contact/block/description/4',
              })}
            </p>
            <Divider />
            <ContactForm />
            <Divider />
          </Col>
        }
      />
    </>
  );
};

export default withPublicWrapper(Contact);
